<template>
  <div class="input">
    <input
      ref="input"
      :value="c_value"
      class="input__input"
      :placeholder="placeholder"
      :class="c_inputClass"
      :type="d_showPassword ? 'text' : type"
      :step="step"
      :disabled="disabled"
      :required="required"
      :min="min"
      :max="max"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <label class="input__label">
      {{ label }}
    </label>
    <i
      v-if="type === 'password'"
      class="link link_gray input__icon"
      role="button"
      :class="d_showPassword ? 'icon-hide' : 'icon-show'"
      @click="togglePasswordVisibility"
    />
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VInput',
  props: {
    modelValue: {
      type: [Number, String, Boolean],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    step: {
      type: [Number, String],
      default: undefined,
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: undefined,
    },
    error: {
      type: [String, Boolean, Array],
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    min: {
      type: [Number, String],
      default: null,
    },
    max: {
      type: [Number, String],
      default: null,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      d_showPassword: false,
    };
  },
  computed: {
    c_error() {
      if (Array.isArray(this.error)) {
        return this.error.length;
      } else {
        return this.error;
      }
    },
    c_value: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
    c_inputClass() {
      const res = [];
      if (this.c_value !== undefined && this.c_value !== null && this.c_value !== '') {
        res.push('input__input_filled');
      }
      if (this.c_error) {
        res.push('input__input_error');
      }
      return res.join(' ');
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.d_showPassword = !this.d_showPassword;
    },
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>

<style lang="scss" scoped></style>
